module.exports = __webpack_public_path__ + "static/media/verticalTrackCardLeftImage.f07d8eeb.svg";